import { createContext } from "react";

export const AppContext = createContext({
	trans: null,
	appConfig: null,
	cLang: '',
	dLang: ''
})